import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import _ from 'underscore';

import {
    Title,
    Form,
    FormInfo,
    FormLine,
    FormLabel,
    FormField,
    FormInput,
    FormTextarea,
    ButtonContainer,
    Button,
    Row,
} from 'yurstrap';

import BackLink from '../BackLink';

import AutoSelect from '../../../components/AutoSelect';

import {
    setCurrentName,
    setCurrentEmail,
    setCurrentMessage,
    setCurrentQuestionType,
    setCurrentPhone,
    getCurrentMessageSelector,
    getCurrentQuestionTypeSelector,
    getCurrentNameSelector,
    getCurrentPhoneSelector,
    postSupportThread,
    getCurrentEmailSelector,
    isQuestionErrorsDisplayedSelector,
} from '../../reduxModules/App';

import {
    checkMessage,
    checkName,
    checkEmail,
    checkQuestionType,
    supportFormHasErrors,
} from '../../constants/FieldsValidation';

import Routes from '../../constants/Routes';
import Scopes from '../../../constants/Scopes';

import {
    isLoadingSelector as isMeLoadingSelector,
    getItemSelector as getMeSelector,
} from '../../../commons/reduxModules/APIMe';

import { getScopeSelector } from '../../../commons/reduxModules/Authentication';

import {
    proQuestionsTypes,
    frontQuestionsTypes,
} from '../../constants/QuestionTypes';

const propTypes = {
    AppActions: PropTypes.shape({
        postSupportThread: PropTypes.func.isRequired,
        setCurrentEmail: PropTypes.func.isRequired,
        setCurrentMessage: PropTypes.func.isRequired,
        setCurrentName: PropTypes.func.isRequired,
        setCurrentPhone: PropTypes.func.isRequired,
        setCurrentQuestionType: PropTypes.func.isRequired,
    }).isRequired,
    user: PropTypes.object,
    currentName: PropTypes.string,
    message: PropTypes.string,
    currentQuestionType: PropTypes.string,
    isLoading: PropTypes.bool.isRequired,
    questionErrorsDisplayed: PropTypes.bool.isRequired,
    currentEmail: PropTypes.string,
    currentPhone: PropTypes.string,
    scope: PropTypes.string.isRequired,
};

const defaultProps = {
    user: null,
    message: '',
    currentQuestionType: '',
    currentName: '',
    currentEmail: '',
    currentPhone: '',
};

class ContactSupportEmail extends Component {

    constructor(props) {
        super(props);
        this.onChangeName = this.onChangeName.bind(this);
        this.onChangeEmail = this.onChangeEmail.bind(this);
        this.onChangeQuestionType = this.onChangeQuestionType.bind(this);
        this.onChangeMessage = this.onChangeMessage.bind(this);
        this.onChangePhone = this.onChangePhone.bind(this);
        this.onSendRequest = this.onSendRequest.bind(this);
        this.renderNoOptionsMessage = this.renderNoOptionsMessage.bind(this);
        this.renderOptionsValue = this.renderOptionsValue.bind(this);
    }

    onChangeEmail(e) {
        const { AppActions } = this.props;
        const { value } = e.target;
        AppActions.setCurrentEmail(value);
    }

    onChangeName(e) {
        const { AppActions } = this.props;
        const { value } = e.target;
        AppActions.setCurrentName(value);
    }

    onChangeQuestionType(value) {
        const { AppActions } = this.props;
        AppActions.setCurrentQuestionType(value);
    }

    onChangePhone(e) {
        const { AppActions } = this.props;
        const { value } = e.target;
        AppActions.setCurrentPhone(value);
    }

    onChangeMessage(e) {
        const { AppActions } = this.props;
        const { value } = e.target;
        AppActions.setCurrentMessage(value);
    }

    onSendRequest() {
        const { AppActions } = this.props;
        AppActions.postSupportThread();
    }

    renderNoOptionsMessage() {
        return 'Aucune question trouvée';
    }

    renderOptionsValue(option) {
        return option.label;
    }

    render() {
        const {
            user,
            message,
            currentName,
            currentEmail,
            currentQuestionType,
            isLoading,
            questionErrorsDisplayed,
            scope,
        } = this.props;
        const userName = user ? `${user.first_name} ${user.last_name}` : '';
        const userEmail = user ? user.email_address : '';
        const userPhone = '';
        const validationNameStatus = !questionErrorsDisplayed
            || checkName(userName)
            || checkName(currentName);
        const validationEmailStatus = !questionErrorsDisplayed
            || checkEmail(userEmail)
            || checkEmail(currentEmail);
        const validationMessageStatus = !questionErrorsDisplayed
            || checkMessage(message);
        const validationQuestionTypeStatus = !questionErrorsDisplayed
            || checkQuestionType(currentQuestionType);
        let name = userName;
        let email = userEmail;
        if (currentName) {
            name = currentName;
        }
        if (currentEmail) {
            email = currentEmail;
        }
        const errorsList = supportFormHasErrors({
            name,
            message,
            email,
            currentQuestionType,
        });
        const selectedOption = user
            ? _.find(frontQuestionsTypes, { label: currentQuestionType })
            : _.find(proQuestionsTypes, { label: currentQuestionType });
        return (
            <>
                <div className="px-5 py--m-5 px--s-3 u-col--m-7 u-col--s-12 u-bg__white" style={{ paddingTop: '120px' }}>
                    <div>
                        <BackLink
                            className="u-display__none u-display__b--s u-display__b--m mb-4"
                            to={Routes.SUPPORT_ROOT.link}
                            style={{ position: 'initial', top: 'auto' }}
                        />
                    </div>
                    <Title>
                        Contact email
                    </Title>
                    <Form>
                        <Row>
                            <FormLine
                                status={validationNameStatus ? 'standard' : 'error'}
                                className="u-col--m-6 u-col--s-12"
                            >
                                <FormLabel>
                                    Nom*
                                </FormLabel>
                                <FormField>
                                    <FormInput
                                        required
                                        onChange={this.onChangeName}
                                        defaultValue={userName}
                                    />
                                </FormField>
                            </FormLine>
                            <FormLine
                                status={validationEmailStatus ? 'standard' : 'error'}
                                className="u-col--m-6 u-col--s-12"
                            >
                                <FormLabel>
                                    Adresse mail*
                                </FormLabel>
                                <FormField>
                                    <FormInput
                                        type="email"
                                        onChange={this.onChangeEmail}
                                        required
                                        defaultValue={userEmail}
                                    />
                                </FormField>
                            </FormLine>
                        </Row>
                        <Row>
                            <FormLine
                                status={validationQuestionTypeStatus ? 'standard' : 'error'}
                                className="u-col--m-6 u-col--s-12"
                            >
                                <FormLabel>
                                    Type de question*
                                </FormLabel>
                                <FormField type="select">
                                    <AutoSelect
                                        placeholder="Choisir"
                                        isClearable={false}
                                        loadingPlaceholder="Chargement..."
                                        noOptionsMessage={this.renderNoOptionsMessage}
                                        options={Scopes.USER === scope
                                            ? frontQuestionsTypes : proQuestionsTypes}
                                        onChange={this.onChangeQuestionType}
                                        getOptionValue={this.renderOptionsValue}
                                        value={selectedOption}
                                    />
                                </FormField>
                            </FormLine>
                            <FormLine
                                status={validationQuestionTypeStatus ? 'standard' : 'error'}
                                className="u-col--m-6 u-col--s-12"
                            >
                                <FormLabel>
                                    Numéro de téléphone
                                </FormLabel>
                                <FormField>
                                    <FormInput
                                        type="phone"
                                        onChange={this.onChangePhone}
                                        defaultValue={userPhone}
                                    />
                                </FormField>
                                <FormInfo>
                                    Ce numéro nous servira à vous recontacter en cas de besoin
                                </FormInfo>
                            </FormLine>
                        </Row>
                        <FormLine status={validationMessageStatus ? 'standard' : 'error'}>
                            <FormLabel>
                                Description de votre problème*
                            </FormLabel>
                            <FormField type="textarea">
                                <FormTextarea
                                    placeholder="Détaillez ici le problème rencontré
                                    (page, action réalisée, navigateur utilisé...)."
                                    value={message}
                                    onChange={this.onChangeMessage}
                                />
                            </FormField>
                        </FormLine>
                        <ButtonContainer>
                            <Button
                                color="premium"
                                className="c-btn--premium"
                                expand
                                onClick={errorsList.length > 0 ? undefined : this.onSendRequest}
                                disabled={errorsList.length > 0 || isLoading}
                            >
                                Envoyer
                            </Button>
                        </ButtonContainer>
                    </Form>
                </div>
            </>
        );
    }

}

ContactSupportEmail.propTypes = propTypes;

ContactSupportEmail.defaultProps = defaultProps;

function mapStateToProps(state) {
    return {
        user: getMeSelector(state),
        currentName: getCurrentNameSelector(state),
        currentEmail: getCurrentEmailSelector(state),
        currentPhone: getCurrentPhoneSelector(state),
        message: getCurrentMessageSelector(state),
        currentQuestionType: getCurrentQuestionTypeSelector(state),
        isLoading: isMeLoadingSelector(state),
        questionErrorsDisplayed: isQuestionErrorsDisplayedSelector(state),
        scope: getScopeSelector(state),
    };
}

function mapDispatchToProps(dispatch) {
    return {
        AppActions: bindActionCreators({
            setCurrentName,
            setCurrentEmail,
            setCurrentMessage,
            setCurrentQuestionType,
            setCurrentPhone,
            postSupportThread,
        }, dispatch),
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(ContactSupportEmail);
